import React from 'react';
import { DraggableProvided, DraggableStateSnapshot } from 'react-beautiful-dnd';
import {
  Card,
  CardContent,
  LinearProgress,
  Typography,
  CardActions,
  CardActionArea
} from '@material-ui/core';
import { Person as PersonIcon } from '@material-ui/icons';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useHistory } from 'react-router-dom';
import { parseTaskStatus } from '../task.helper';
import { Task } from '../Task.interface';

export interface BoardItemProps {
  subTask?: boolean;
  task: Task;
  provided?: DraggableProvided;
  snapshot?: DraggableStateSnapshot;
  isLoading?: boolean;
  onSelectTask?: (task: Task) => void;
}

const BoardItem: React.FC<BoardItemProps> = (props: BoardItemProps) => {
  const { subTask, task, provided, isLoading, onSelectTask } = props;

  const assignedUser: any | undefined = task.user || task.modifiedBy;
  const assignedName = assignedUser
    ? `${assignedUser.firstName} ${assignedUser.lastName}`
    : '';

  const Contents = () => {
    return (
      <>
        {isLoading && <LinearProgress />}
        {!subTask && (
          <CardContent>
            <Typography variant='body1'>{task.name}</Typography>
            <Typography variant='caption'></Typography>
          </CardContent>
        )}
        <CardContent className='info'>
          <div className='assigned'>
            <div className='icon-wrapper'>
              <PersonIcon />
            </div>
            {assignedName}
          </div>
          {parseTaskStatus(task.status) === 'Approved' && (
            <CheckCircleIcon color='primary' />
          )}
        </CardContent>
      </>
    );
  };

  if (provided) {
    return (
      <Card
        className='task-card'
        ref={provided && provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        onClick={() => onSelectTask?.(task)}
      >
        <Contents />
      </Card>
    );
  } else {
    return (
      <Card className='task-card'>
        <Contents />
      </Card>
    );
  }
};

export default BoardItem;
